import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowUp } from 'lucide-react';

/**
 * ScrollToTop
 * - Automatically scrolls to top on route change.
 * - Shows a floating button when the user scrolls down > 300px.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  // Reset scroll position on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  // Show / hide the back-to-top button
  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed right-4 bottom-4 z-50 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-[#00bcd4]/10 text-gray-500 shadow-md backdrop-blur-2xl transition-all duration-300 hover:scale-110 hover:bg-[#00a0b0] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00bcd4] focus-visible:ring-offset-2 md:h-11 md:w-11 ${
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
      }`}
    >
      <ArrowUp className="h-4 w-4 md:h-6 md:w-6" strokeWidth={2.5} />
    </button>
  );
};

export default ScrollToTop;
